// extracted by mini-css-extract-plugin
module.exports = {"navLink":"InternalHeaderLinks_navLink__1D5PO","active":"InternalHeaderLinks_active__7nPvW"};